import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Typography,
  TextField,
} from '@mui/material';

export default function YearlyPattern({
  interval,
  onIntervalChange,
  byMonth,
  onByMonthChange,
  byMonthDay,
  onByMonthDayChange,
}) {
  const { t } = useTranslation('common');

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      {/* Interval Input */}
      <Box display="flex" alignItems="center" gap={1}>
        <Typography>{t('common:rrule.pattern.every')}</Typography>
        <TextField
          type="number"
          value={interval}
          onChange={(e) => onIntervalChange(Math.max(1, parseInt(e.target.value) || 1))}
          slotProps={{ htmlInput: { min: 1, style: { textAlign: 'center' } } }}
          size="small"
          sx={{ width: 70 }}
        />
        <Typography>{t('common:rrule.pattern.every_years')}</Typography>
      </Box>

      {/* Month and day selector */}
      <Box display="flex" alignItems="center" gap={2}>
        <Box>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            {t('common:rrule.pattern.in_month')}
          </Typography>
          <TextField
            type="number"
            value={byMonth}
            onChange={(e) => onByMonthChange(Math.min(12, Math.max(1, parseInt(e.target.value) || 1)))}
            slotProps={{ htmlInput: { min: 1, max: 12, style: { textAlign: 'center' } } }}
            size="small"
            sx={{ width: 70 }}
          />
        </Box>
        <Box>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            {t('common:rrule.pattern.on_day')}
          </Typography>
          <TextField
            type="number"
            value={byMonthDay}
            onChange={(e) => onByMonthDayChange(Math.min(31, Math.max(1, parseInt(e.target.value) || 1)))}
            slotProps={{ htmlInput: { min: 1, max: 31, style: { textAlign: 'center' } } }}
            size="small"
            sx={{ width: 70 }}
          />
        </Box>
      </Box>
    </Box>
  );
}
